import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/company/_management/analytics/company-overview',
)({
  beforeLoad: async () => {
    return redirect({
      to: '/company/analytics',
    })
  },
})
